<template>
  <div>
    <span>{{ imagem.name }}</span>
    <template v-if="isImage(imagem.name)">
      <img
        :id="imagem.id_file"
        :alt="imagem.name"
      >
    </template>
    <template v-else-if="isPdf(imagem.name)">
      <iframe
        :id="imagem.id_file"
        width="100%"
        height="600px"
        style="height: 600px !important;"
      />
    </template>
    <template v-else>
      Arquivo inválido :(
    </template>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Spinner from '@/components/common/Spinner'

export default {
  name: 'PendenciesImagesModal',
  components: {
    Spinner
  },
  props: {
    imagem: {
      type: Object
    }
  },
  methods: {
    ...mapActions(['pendencyDownloadTransferedFile']),
    isImage(fileName) {
      return /\.(jpg|jpeg|png|gif)$/i.test(fileName)
    },
    isPdf(fileName) {
      return /\.pdf$/i.test(fileName)
    },
    getFileExtension(fileName) {
      return fileName.split('.').pop();
    },
  },
  created () {
    this.pendencyDownloadTransferedFile({fileId: this.imagem.id_file, fileExtension: this.getFileExtension(this.imagem.name)})
      .then(({url}) => {
        console.info(url)
        let img = document.getElementById(this.imagem.id_file)
        img.src = url
      })
  }
}
</script>

<style lang="scss">
</style>
